import {
  CalendarCheck,
  CalendarDays,
  CalendarHeart,
  CalendarMinus,
  CalendarOff,
  CalendarX,
  type LucideIcon,
} from 'lucide-react';
import type { StatusColorTone } from '@/styles/statusColors';
import type {
  LeaveReportDateCategory,
  LeaveReportDayKind,
  LeaveReportItem,
} from '../types/leaveReport.types';

export const LEAVE_REPORT_PAGE_SIZE = 20;

export const LEAVE_REPORT_DATE_COUNT_KEY = {
  absent: 'absentDays',
  weekend: 'weekendDays',
  holiday: 'holidayDays',
  total: 'totalDays',
  applied: 'appliedDays',
  unapplied: 'unappliedDays',
} as const satisfies Record<LeaveReportDateCategory, keyof LeaveReportItem>;

interface DateCategoryStyle {
  label: string;
  icon: LucideIcon;
  dayKinds: readonly LeaveReportDayKind[];
  canOpenHolidayCalendar?: boolean | undefined;
}

export const LEAVE_REPORT_DATE_CATEGORY: Record<LeaveReportDateCategory, DateCategoryStyle> = {
  absent: { label: 'Absent Days', icon: CalendarX, dayKinds: ['absent'] },
  weekend: { label: 'Weekends', icon: CalendarOff, dayKinds: ['weekend'] },
  holiday: {
    label: 'Govt Holidays',
    icon: CalendarHeart,
    dayKinds: ['holiday'],
    canOpenHolidayCalendar: true,
  },
  total: {
    label: 'Total Days',
    icon: CalendarDays,
    dayKinds: ['present', 'absent', 'weekend', 'holiday'],
    canOpenHolidayCalendar: true,
  },
  applied: { label: 'Applied Days', icon: CalendarCheck, dayKinds: ['applied'] },
  unapplied: { label: 'Unapplied Days', icon: CalendarMinus, dayKinds: ['unapplied'] },
};

interface DayKindStyle {
  label: string;
  tone: StatusColorTone;
}

export const LEAVE_REPORT_DAY_KIND: Record<LeaveReportDayKind, DayKindStyle> = {
  present: { label: 'Present', tone: 'success' },
  absent: { label: 'Absent', tone: 'danger' },
  weekend: { label: 'Weekend', tone: 'neutral' },
  holiday: { label: 'Govt Holiday', tone: 'info' },
  applied: { label: 'Applied', tone: 'info' },
  unapplied: { label: 'Unapplied', tone: 'warning' },
};
